module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAICAYAAADA+m62AAAAAXNSR0IArs4c6QAAAK5JREFUGBllkE0KwjAQhTvxLl7AK3TTEyQbxY2Kglfw7wYitCC40E2ysFcRbxS/iaYEHJjMm3mvL9NICGEWY7yLyN45d6qKgGtp53BTA/kAdAx2EJesU4zBiv5mre2lIPTrJdkhqKljDFqMtqoZhNp476+UhWJEL0QTxRrmW/5PXN/ldHD8LZ6uRjAiE85XJ8dSpAS5QahrrFnnTK0EUXoeY8yBvzvqMAfcE9zA1R9b3EXkt12arQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/cancel_black.png
// module id = 15
// module chunks = 7